import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { LAYOUT_BREAK_SMALL } from '../../containers/App/constants';

const Container = styled.div`
  max-width: ${props => (props.maxWidth ? props.maxWidth : '')};
  min-width: ${props => (props.minWidth ? props.minWidth : '')};
  .react-select-container {
    min-width: 175px;
  }
`;

export const SearchSelect = props => {
  return (
    <Container maxWidth={props.maxWidth} minWidth={props.minWidth}>
      <Select
        isMulti={props.isMulti}
        isClearable={props.isClearable}
        isSearchable={props.isSearchable}
        isDisabled={props.disabled}
        options={props.options}
        value={props.value}
        onChange={props.onChange}
        className="react-select-container"
        classNamePrefix="react-select"
        {...props}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderRadius: '0%',
            border: '1px solid',
            height: window.innerWidth > LAYOUT_BREAK_SMALL ? '45px' : 'auto',
            fontSize: '14px',
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            fontSize: '18px',
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: '18px',
          }),
          singleValue: (baseStyles) => ({
            ...baseStyles,
            fontSize: '18px',
          }),
          placeholder: (baseStyles) => ({
            ...baseStyles,
            fontSize: '18px',
          }),
        
        }}
      />
    </Container>
  );
};
